export default function BrandListSkeleton() {
	return (
		<div className="space-y-2">
			{Array.from({ length: 5 }).map((_, index) => (
				<div key={index} className="flex items-center rounded-xl justify-between py-4 px-4 border border-gray-200 bg-white animate-pulse">
					<div className="flex items-center gap-4">
						<div className="w-10 h-10 bg-gray-200 rounded-lg" />
						<div className="flex flex-col gap-2">
							<div className="h-4 w-32 bg-gray-200 rounded" />
							<div className="h-3 w-20 bg-gray-200 rounded" />
						</div>
					</div>
					<div className="h-5 w-16 bg-gray-200 rounded" />
				</div>
			))}
		</div>
	);
}
